module.exports = __webpack_public_path__ + "af6be9630f0f38d88a35727758931107.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/will-klein.jpg
// module id = 483
// module chunks = 0